import { createAction, handleActions } from 'redux-actions';

const setFilters = createAction("SCREENS/CLIENTS/SET_FILTERS");

const defaultState = {
  status_key: 'all'
};

const reducer = handleActions(
  {
    [setFilters]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setFilters, reducer };